import { useAddCarrier } from "@babackapp/private-api-client/client/use-add-carrier";
import { useAddUpsCarrier } from "@babackapp/private-api-client/client/use-add-ups-carrier";
import { useCarriersQuery } from "@babackapp/private-api-client/client/use-carriers-query";
import { useDeleteCarrierPricing } from "@babackapp/private-api-client/client/use-delete-carrier-pricing";
import { useEditCarrierPriciings } from "@babackapp/private-api-client/client/use-edit-carrier-pricings";
import { useEditCarrierTransport } from "@babackapp/private-api-client/client/use-edit-carrier-transport";
import useRefreshShippingMethods from "@babackapp/private-api-client/client/use-refresh-shipping-methods";
import useShop from "@babackapp/private-api-client/client/use-shop";
import useUpdateShopPreferences from "@babackapp/private-api-client/client/use-update-shop-preferences";
import useUpdateRoutingLocationRules from "@babackapp/private-api-client/client/use-update-shop-routing-location-rules";
import SettingsFormContainer, {
  SettingsFormHeader,
} from "@babackapp/react-hook-forms-components/form-page";
import useTranslation from "@babackapp/translations/use-translation";
import { useParams } from "react-router-dom";
import CarriersInformations from "./carriers-informations/carriers-informations";
import { CarriersPricings } from "./carriers-informations/components/carriers-pricings";
import LocationsList from "./locations/locations-list";
import { CarriersProvider } from "./use-carriers-context";
import { ShippingMethodsCard } from "./shipping-methods-card";

export default function Carriers() {
  const t = useTranslation();
  const shopId = useParams<{ shopId: string }>().shopId as string;
  const { data: shop } = useShop(shopId);
  const { data: carriers } = useCarriersQuery(shopId);
  const { mutate: addCarrier } = useAddCarrier(shopId);
  const { mutate: editCarrierTransport } = useEditCarrierTransport(shopId);
  const { mutate: editCarrierPricings } = useEditCarrierPriciings(shopId);
  const { mutate: deleteCarrierPricing } = useDeleteCarrierPricing(shopId);
  const { mutate: updateShopPreferences } = useUpdateShopPreferences(shopId);
  const { mutateAsync: updateRoutingRules } =
    useUpdateRoutingLocationRules(shopId);
  const { mutate: addUpsCarrier } = useAddUpsCarrier(shopId);

  const updateShopPreferenceCanReturnWithoutLabel = (canReturn: boolean) =>
    updateShopPreferences({
      canReturnWithoutLabel: canReturn,
    });

  const { mutateAsync: refreshShippingMethods } =
    useRefreshShippingMethods(shopId);

  if (!shop) return <></>;
  return (
    <CarriersProvider
      carriers={carriers || []}
      shop={shop}
      addOneCarrierTransport={addCarrier}
      editOneCarrierTransport={editCarrierTransport}
      editCarrierPricingsTransport={editCarrierPricings}
      deleteCarrierPricing={deleteCarrierPricing}
      updateShopPreferenceCanReturnWithoutLabel={
        updateShopPreferenceCanReturnWithoutLabel
      }
      editOneCarrierRutingRule={updateRoutingRules}
      addOneUpsCarrierTransport={addUpsCarrier}
      refreshShippingMethods={refreshShippingMethods}
    >
      <SettingsFormContainer>
        <SettingsFormHeader
          title={t("settings.carriers.title")}
          description={t("settings.carriers.subtitle")}
        />
        <LocationsList />
        <CarriersInformations />
        <ShippingMethodsCard />
        <CarriersPricings />
      </SettingsFormContainer>
    </CarriersProvider>
  );
}
